import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";

export default function AboutPrincipal() {
  const state = useSelector((state) => state);

  const [size, setSize] = useState("contain");
  const [position, setPosition] = useState("top");

  useEffect(() => {
    setInterval(() => {
      setSize("cover");
      setPosition("center");
    }, 500);
  }, []);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            backgroundSize: size,
            backgroundPosition: position,
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url(" +
              require("../img/bg5.jpg") +
              ")",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "40px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            About Principal
          </div>
        </div>
        <div style={{ marginTop: "100px" }} />

        <div className="aboutabout" style={{ marginTop: "50px" }}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                About the Principal
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "1.2vw",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Mrs. Suma Konduru is a trailblazing educational luminary,
                distinguished by her stellar academic credentials and extensive
                experience in cultivating young minds. Holding a remarkable
                amalgamation of degrees - M.Sc. in BioTechnology, M.Sc. in
                Chemistry, M.Ed., and a Postgraduate Diploma in Integrated
                Counselling - Mrs. Suma Konduru brings a unique synergy of
                scientific sagacity, pedagogical expertise, and emotional
                intelligence to her role as Principal. With over 14 years of
                experience navigating diverse curricula across various states,
                Mrs. Suma Konduru possesses a profound and nuanced understanding
                of the educational landscape. Her multidisciplinary expertise
                enables her to foster a holistic learning environment that
                nurtures academic excellence, emotional resilience, and social
                responsibility. As a visionary educator and compassionate
                leader, Mrs. Suma Konduru is dedicated to empowering students,
                teachers, and the broader school community. Her unwavering
                commitment to excellence, inclusivity, and innovation has
                created a vibrant and supportive school ecosystem, where every
                individual can thrive, grow, and reach their full potential."
                <br />
                <br />
                <b>Mrs. Suma Konduru</b>
                <br />
                Principal, BGS World School
              </div>
            </Grid>
            <Grid item xs={12} md={5}>
              <img
                style={{
                  width: "100%",
                  objectFit: "cover",
                  margin: "0px",
                  height: "60%",
                }}
                src={require("../img/asdds.jpeg")}
              />
            </Grid>
          </Grid>
        </div>
        <div style={{ marginTop: "-150px" }} />
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
